<template>
  <div class="view-recommendation-program">
    <view-container
      title="Indique & Ganhe"
      subtitle="Compartilhe o seu link único para começar a faturar. <a class='text-primary ml-3' target='_blank' href='https://blitzpay.tawk.help/article/programa-indique-e-ganhe-blitzpay'><i class='fa-light fa-circle-info'/></a>"
      :breadcrumbs="[{ title: 'Indique & Ganhe' }]"
      header
    >
      <div class="pt-6 pb-9">
        <div class="row mb-6">
          <div class="col-lg-8">
            <div class="card">
              <action-dispatcher action="rewards/getReference">
                <div class="row align-items-center">
                  <div class="col-lg-12 mb-5 mb-lg-0">
                    <div class="px-lg-5">
                      <div
                        class="d-flex justify-content-between align-items-center mb-6"
                      >
                        <button
                          class="btn font-weight-normal ellipsis text-primary fs-16 btn-sm p-0"
                          @click="copyLink"
                        >
                          <span>
                            {{ recommendationProfile.url }}
                          </span>
                        </button>
                        <button class="btn p-0 ml-3" @click="copyLink">
                          <i class="fa-regular fa-copy fs-20 text-primary" />
                        </button>
                      </div>
                      <div class="text-secondary">Link único</div>
                    </div>
                  </div>
                  <!-- <div class="col-lg-4 pt-5 pt-lg-0 tax-info">
                    <div class="px-lg-5">
                      <div class="d-flex align-items-center mb-6">
                        <span> {{ recommendationProfile.tax }}% </span>
                      </div>
                      <div class="text-secondary">Taxa de indicação</div>
                    </div>
                  </div> -->
                </div>
              </action-dispatcher>
            </div>
          </div>
          <div class="col-lg-4 mt-5 mt-lg-0">
            <div class="card text-secondary d-flex justify-content-center">
              <action-dispatcher action="rewards/getRecommendationTotal">
                <div class="px-3">
                  <div
                    class="d-flex justify-content-between align-items-center mb-6"
                  >
                    <span class="fs-22">
                      <small class="fs-12">R$</small>
                      {{ amount }}
                    </span>
                    <i class="fa-solid fa-wallet fs-20" />
                  </div>
                  <span>Saldo a receber no programa</span>
                </div>
              </action-dispatcher>
            </div>
          </div>
        </div>

        <b-tabs content-class="mt-6" class="my-6">
          <b-tab title="Comissões a receber" active>
            <comissions />
          </b-tab>
          <b-tab title="Produtores indicados">
            <div class="row mb-5">
              <div class="col-lg-8 mb-5 mb-lg-0">
                <div class="d-flex align-items-start">
                  <div class="d-flex flex-column">
                    <div>
                      <span class="text-primary fs-12">
                        Qtd: {{ pagination.count || 0 }}
                      </span>
                      <button
                        class="btn p-0 text-primary ml-3"
                        @click="dispatch"
                      >
                        <i class="fa-solid fa-refresh" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-4">
                <div class="d-flex justify-content-end">
                  <search-button @search="searching" />

                  <button
                    type="button"
                    class="btn btn-primary btn-sm btn-40 btn-square ml-3"
                    @click="exportCSV"
                  >
                    <loading :show="exportLoading">
                      <i class="fa-solid fa-download" />
                    </loading>
                  </button>
                </div>
              </div>
            </div>

            <div v-if="loading" class="text-center">
              <b-spinner variant="primary" />
            </div>

            <div
              v-else-if="!recommendations.length"
              class="container centralize-row text-center pt-5"
            >
              <div class="row justify-content-center">
                <div class="col-lg-5">
                  <img
                    class="d-block mb-9 mx-auto"
                    src="@/assets/images/home/welcome.png"
                  />
                  <h5>Você ainda não indicou produtores</h5>
                  <div class="text-secondary mb-5">
                    Copie o link acima para começar
                  </div>
                </div>
              </div>
            </div>

            <div v-else>
              <!-- Desktop area -->
              <data-table
                class="d-none d-lg-block"
                :lastColumnFr="1"
                :firstColumnFr="1"
                :columns="columns"
                :data="recommendations"
                new-design
              >
                <template #default="{item}">
                  <div>
                    <strong class="text-secondary">
                      {{ item.name }}
                    </strong>
                    <div class="mt-2">{{ item.email }}</div>
                  </div>
                  <div>{{ formatDate(item.created_at) }}</div>
                  <!-- <div>{{ item.tax }} %</div> -->
                </template>
              </data-table>
              <!-- End of desktop -->

              <!-- Mobile area -->
              <data-table
                class="d-lg-none"
                :columns="['', '']"
                :data="recommendations"
                new-design
              >
                <template #default="{item}">
                  <div class="d-flex flex-column">
                    <small class="mb-2">
                      <strong>Nome do indicado:</strong> {{ item.name }}
                    </small>
                    <small> <strong>E-mail:</strong> {{ item.email }} </small>
                    <small><strong>Taxa: </strong>{{ item.tax }} %</small>
                  </div>
                </template>
              </data-table>
              <!-- End of mobile -->
            </div>
            <div class="d-flex justify-content-center mt-6">
              <paginator
                v-show="recommendations.length"
                :pagination="pagination"
                @on-update="onPaginationUpdate"
              />
            </div>
          </b-tab>
        </b-tabs>
      </div>
    </view-container>
  </div>
</template>

<script>
import Comissions from "@/components/recommendation/Comissions.vue";
import { clearObject, formatMoney } from "@/functions/helpers";
import moment from "moment";
import { mapState } from "vuex";
export default {
  components: { Comissions },
  data() {
    return {
      offset: null,
      loading: false,
      exportLoading: false,
      columns: ["Nome do indicado", "Data de inscrição"]
    };
  },
  computed: {
    ...mapState("rewards", [
      "recommendationProfile",
      "recommendationTotal",
      "recommendations",
      "pagination"
    ]),
    amount() {
      return formatMoney(this.recommendationTotal);
    }
  },
  methods: {
    searching(v) {
      this.search = v;
      this.dispatch();
    },
    formatDate(val) {
      if (val) val = val.replace("Z", "");
      return val ? moment(val).format("DD/MM/YYYY") : "-";
    },
    onPaginationUpdate(offset) {
      this.offset = offset;
      this.dispatch();
    },
    dispatch() {
      this.loading = true;
      this.$store
        .dispatch(
          "rewards/getRecommendations",
          clearObject({
            offset: this.offset,
            search: this.search
          })
        )
        .finally(() => (this.loading = false));
    },
    async exportCSV() {
      try {
        this.exportLoading = true;
        const data = await this.$store.dispatch(
          "rewards/exportRecommendations",
          clearObject({
            export: true,
            offset: this.offset
          })
        );

        var a = document.createElement("a");
        a.href = `data:text/csv;charset=utf-8,${data.replaceAll("#", "%23")}`;
        a.setAttribute(
          "download",
          `recommendations_${moment().format(
            "YYYYMMDD"
          )}_${moment().unix()}.csv`
        );
        a.click();
      } catch (e) {
      } finally {
        this.exportLoading = false;
      }
    },
    copyLink() {
      navigator.clipboard.writeText(this.recommendationProfile.url);
      this.$message.success("Link copiado");
    }
  },
  mounted() {
    this.dispatch();
  }
};
</script>
<style lang="scss" scoped>
.view-recommendation-program {
  .card {
    height: 100%;
    padding: 24px 20px;
    border-radius: 10px;
    border: 1px solid #f0eff2;
    box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.05);
    .tax-info {
      border-top: 1px solid rgba(219, 221, 230, 0.85);
      @media screen and (min-width: 992px) {
        border-left: 1px solid rgba(219, 221, 230, 0.85);
        border-top: none;
      }
    }
  }
  .ellipsis {
    display: block;
    text-overflow: ellipsis;
    overflow: hidden;
    word-wrap: break-word;
    white-space: pre;
  }
}
</style>
